
const digest = 'b4dd4a079f1c164cee5d974c313df350963f92afa316655e0a3073f71d38f12c';
const classes = {"wrapper":"_wrapper_1xqd1_1","date":"_date_1xqd1_12","content":"_content_1xqd1_19","controls":"_controls_1xqd1_26"};
const css = `._wrapper_1xqd1_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 28px;
  border: 1px solid #eaedf3;
  border-top: 0;
}
._wrapper_1xqd1_1:first-of-type {
  border-top: 1px solid #eaedf3;
}
._wrapper_1xqd1_1 ._date_1xqd1_12 {
  font-size: 14px;
  color: #000000;
  max-width: 120px;
  padding: 24px 0 24px 24px;
  min-width: 160px;
}
._wrapper_1xqd1_1 ._content_1xqd1_19 {
  flex-grow: 1;
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 24px 0;
}
._wrapper_1xqd1_1 ._controls_1xqd1_26 {
  min-width: 100px;
  max-width: 100px;
  border-left: 1px solid #eaedf3;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  margin: -24px 0;
  gap: 16px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  